/**
 * 用户信息
 */

import { login, user_info, logout } from '@/api/login'
import { getToken, setToken, removeToken, getRoles, setRoles } from '@/utils/auth'

export default {
  state: {
    token: getToken(),  // sid
    roles: getRoles(),  // 角色['admin', 'taoke']
    info: {

      // 淘客用户信息
      id: '', //  主推用户id
      taobao_expires_at: '',  //  淘宝授权过期时间
      telephone: '',  //  手机号码
      email: '',      //  邮箱
      money: '',      //  淘宝客的余额
      taobao_nickname: '',  //  淘宝昵称
      taobao_userid: '',  // 淘宝用户id
      sex: '',            //  性别: 0保密 1男 2女
      birthday: '',       //  生日 YYYY-MM-DD
      province: '',       //  省: '广东省'
      city: '',           //  市: '广州市'
      qq: '',             //  qq: ''
      job: '',            //  工作类型: [公司 工作室/团队/其他组织 自由职业]
      company: '',        //  单位名称: ''
      job_title: '',      //  部门或职位: ''
      work_type: '',      //  工作性质: 兼职 全职
      sale_type: '',      //  推广方式: 'QQ群,微信,微博,网站,APP,线下推广'
      income_type: '',    //  推广收益
      wx_share_pid: '',   //  微信分享pid
      wb_share_pid: '',   //  微博分享pid
      qq_share_pid: '',   //  qq分享pid
      inv_code: '',       //  邀请朋友code
      vip: '',            //  vip等级: 1 导购版 2用户中心版 3返利代理版 4尊享版
      vip_expires_at: '', //  vip到期时间
      password_updatetime: '', // 密码修改时间

      // 管理员用户信息
      // code...
    },
  },
  mutations: {
    SET_ROLES: (state, roles) => { state.roles = roles },
    SET_TOKEN: (state, token) => { state.token = token },
    SET_USER_INFO: (state, info) => { state.info = { ...info } },
  },
  actions: {
    // 登录
    Login({ commit }, data) {

      // 生产环境下不允许调用这里的login
      if (process.env.NODE_ENV != 'development') {
        return Promise.reject('不允许在该页面登录，请联系客服')
      }

      // 判断是否是管理员
      const isadmin = data.isadmin || false
      delete data.isadmin

      return new Promise((resolve, reject) => {
        login(data, isadmin).then((res) => {
          const { data } = res
          if (data.error_code == 0) {
            // 用户登录信息
            const sid = data.asid || data.tsid || data.csid
            commit('SET_TOKEN', sid)
            setToken(sid)

            // 用户角色
            const role = data.asid ? 'admin' : data.tsid ? 'taoke' : 'csm'
            commit('SET_ROLES', [role])
            setRoles([role])
          }

          resolve(data)
        }, reject)
      })
    },

    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        user_info(state.token).then((res) => {
          if (!res.data) return reject('error')

          if (res.data.error_code != 0) {
            return reject(res.data.error_message)
          }

          const { info } = res.data
          info.taobao_expires_at *= 1000
          info.pdd_expires_at *= 1000
          // commit('SET_USER_INFO', limitObject(info, Object.keys(INFO), true))
          commit('SET_USER_INFO', info)
          commit('UPDATE_AUTHREMAIN7DAY', { taobao_expires_at: info.taobao_expires_at, pdd_expires_at: info.pdd_expires_at })
          resolve(info)
        }, reject)
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      commit('SET_ROLES', [])
      commit('SET_TOKEN', '')
      removeToken()
      // commit('SET_USER_INFO', {})
    },

    // 登出
    LogOut({ dispatch }) {
      logout()
      dispatch('FedLogOut')
    },
  },
}